import { CommonDialog } from '../../common'
import { HelpCenterProps } from './_props'
import { HelpCenterCardsContainer } from './HelpCenterCardsContainer'

export const HelpCenter = ({ open, onClose, onClick }: HelpCenterProps) => {
    return (
        <CommonDialog
            title="Besoin d’aide ou d’une information ?"
            subtitle="Nous sommes là pour vous !"
            open={open}
            onClose={onClose}
        >
            <HelpCenterCardsContainer
                contentType={{
                    helpCenterAndTutorials: true,
                    supportContact: true,
                    exchangeViews: true,
                }}
                onClick={onClick}
            />
        </CommonDialog>
    )
}
